var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.languages),function(language){return _c('div',{key:language.id},[(_vm.selectedLanguage.id === language.id)?_vm._t(language.symbol.toLowerCase()):_vm._e()],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad93a74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LanguageSwitch.vue
// module id = 1184
// module chunks = 0